import { render, staticRenderFns } from "./IncidentRestrictedAccessModal.vue?vue&type=template&id=5fa95399&lang=pug"
import script from "./IncidentRestrictedAccessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentRestrictedAccessModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports